import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CellContext, injectFlexRenderContext } from '@tanstack/angular-table';

@Component({
  template: `
    <mat-checkbox
      [checked]="context.row.getIsSelected()"
      (change)="context.row.getToggleSelectedHandler()($event)"
    ></mat-checkbox>
  `,
  styleUrls: ['./datatable-row-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCheckboxModule]
})
export class DatatableRowSelectionComponent<T> {
  context = injectFlexRenderContext<CellContext<T, unknown>>();
}
